import { render, staticRenderFns } from "./externalJump.vue?vue&type=template&id=642cdcc8"
import script from "./externalJump.vue?vue&type=script&lang=js"
export * from "./externalJump.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports